import type { AuthContextType } from "../../features/auth/AuthContext";

export function canShowInhouseFeatures(auth: AuthContextType): boolean {
  const environment = import.meta.env.VITE_APP_ENV ?? (import.meta.env.DEV ? "LOCAL" : undefined);
  return environment === "LOCAL" || environment === "DEV"
    || auth.isStaff() || auth.isImpersonating();
}
